import api from "../../api";

const state = {
  companies: [],
  transactions: [],
  customers: [],
  customersACT: [],
  customerINA: [],
  terminals: [],
  terminalsAndServices: [],
  loading_company: true,
  loading_transaction_report: true,
  loading_services: true,
  loading_customer: true,
  loading_terminales: true,

  show_terminal: false,
  show_customer: false,
  show_customer_ACT: false,
  show_customer_INA: false,
  show_services: false,
  label: ""
};

const getters = {
  label: (state) => {
    return state.label;
  },
  service_view: (state) => {
    return state.show_services;
  }
};
const mutations = {
  loadingTerminal(state, payload) {
    state.loading_terminales = payload;
  },
  showterminals(state, payload) {
    state.show_terminal = payload;
  },
  loadingCustomer(state, payload) {
    state.loading_customer = payload;
  },
  showcustomer(state, payload) {
    state.show_customer = payload;
  },
  showcustomerACT(state, payload) {
    state.show_customer_ACT = payload;
  },
  showcustomerINA(state, payload) {
    state.show_customer_INA = payload;
  },
  loading_services(state, payload) {
    state.loading_services = payload;
  },
  set_servicesDrawer(state, payload) {
    state.show_services = payload;
  },
  set_label(state, payload) {
    state.label = payload;
  },
  set_company(state, payload) {
    state.companies = payload;
    state.loading_company = false;
  },
  set_transaction(state, payload) {
    state.transactions = payload;
  },
  set_customer(state, payload) {
    state.customers = payload;
  },
  set_customerACT(state, payload) {
    state.customersACT = payload;
  },
  set_customerINA(state, payload) {
    state.customerINA = payload;
  },
  set_terminals(state, payload) {
    state.terminals = payload;
  },
  set_services(state, payload) {
    state.terminalsAndServices = payload;
  },
  set_loading_transaction_report(state, payload) {
    state.loading_transaction_report = payload;
  }
};

const actions = {
  hide(context, payload) {
    context.commit("set_servicesDrawer", payload);
    context.commit("showcustomer", false);
    context.commit("showcustomerACT", false);
    context.commit("showcustomerINA", false);
    context.commit("showterminals", false);
  },
  async getAllCompany(context) {
    const { data } = await api.get("/api/tennos/GetEmpresas");
    context.commit("set_company", data);
  },
  async getTransactionReport(context, declined) {
    context.commit("set_loading_transaction_report", true);
    const { data } = await api.get(
      `/api/tennos/GetTransactionReport?declined=${declined}`
    );
    context.commit("set_transaction", data);
    context.commit("set_loading_transaction_report", false);
  },
  async getAllTerminals(context, payload) {
    context.commit("showterminals", true);
    const { data } = await api.get(
      `/api/tennos/GetAllTemrinalByEmpresa?rnc=${payload.rnc}`
    );
    context.commit("loadingTerminal", false);
    context.commit("set_terminals", data);
  },
  async getAllTerminalAndServicesAsync({ commit }, payload) {
    switch (payload.type) {
      case 1:
        commit("set_label", "Terminales con servicios ncfmovil");
        break;
      case 2:
        commit("set_label", "Terminales con servicios magypago");
        break;
      case 3:
        commit("set_label", "Terminales con servicios fidelizacion");
        break;
      default:
        break;
    }
    commit("set_servicesDrawer", true);
    const { data } = await api.get(
      `/api/tennos/GetTerminalsByServicesAndRnc?rnc=${payload.Rnc}&typeOfService=${payload.type}`
    );
    commit("loading_services", false);
    commit("set_services", data);
  },
  async getAllCustomer(context, payload) {
    context.commit("showcustomer", true);
    const { data } = await api.get(
      `/api/tennos/GetCustomerByEmpresaid?empresaId=${payload.empresaid}`
    );
    context.commit("loadingCustomer", false);
    context.commit("set_customer", data);
  },
  async getAllCustomerACT(context, payload) {
    context.commit("showcustomerACT", true);
    const { data } = await api.get(
      `/api/tennos/GetCustomerACT_ByEmpresaid?empresaId=${payload.empresaid}`
    );
    context.commit("loadingCustomer", false);
    context.commit("set_customerACT", data);
  },
  async getAllCustomerINA(context, payload) {
    context.commit("showcustomerINA", true);
    const { data } = await api.get(
      `/api/tennos/GetCustomerINA_ByEmpresaid?empresaId=${payload.empresaid}`
    );
    context.commit("loadingCustomer", false);
    context.commit("set_customerINA", data);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
